.topContainer {
  border-bottom: 1px solid #eee;
  display: flex;
  flex-direction: row-reverse;
  padding: 8px 15px;
}
